// extracted by mini-css-extract-plugin
module.exports = {"logInModal":"styles_logInModal__xbmyS","logInBttn":"styles_logInBttn__p9txm","Modal":"styles_Modal__sq2Wu"};